module.exports = __webpack_public_path__ + "img/premium-satin_thumbnail_mobile.c5da4f1e.jpg";